'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/shareReplay';

let online$;

/**
 * @return {Observable<boolean>}
 */
export function getOnline$() {
  if (online$) {
    return online$;
  } else if ('ononline' in window) {
    online$ = Observable.merge(
      Observable.of(global.window.navigator.onLine),
      Observable.fromEvent(global.window, 'online').mapTo(true),
      Observable.fromEvent(global.window, 'offline').mapTo(false),
    ).shareReplay(1);

    return online$;
  } else {
    online$ = Observable.of(true).shareReplay(1);

    return online$;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/network/index.js